import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
// Neues Icon importieren
import CloudIcon from "@mui/icons-material/Cloud";

// Data
import useDataTableData from "./data/dataTableData";

function ProductsList() {
  const { columns, rows } = useDataTableData(); // Daten aus der REST-Abfrage laden

  const tableData = {
    columns,
    rows,
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1} display="flex" alignItems="center">
              <SoftTypography variant="h5" fontWeight="medium">
                Ihre Services
              </SoftTypography>
            </SoftBox>
            <Stack spacing={1} direction="row">
              <Link to="/iaas/discover">
                <SoftButton variant="gradient" color="info" size="small">
                  + Neuer Service
                </SoftButton>
              </Link>
            </Stack>
          </SoftBox>
          <DataTable
            table={tableData}
            entriesPerPage={{
              defaultValue: 7,
              entries: [5, 7, 10, 15, 20, 25],
            }}
            canSearch
          />
        </Card>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ProductsList;
